import script from "./ChangePassword.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChangePassword.vue?vue&type=script&lang=ts&setup=true"

import "@/assets/styles/scss/password.scss?vue&type=style&index=0&lang=scss"

const __exports__ = script;

export default __exports__